module.exports = __webpack_public_path__ + "static/img/bg8.d482b2d5.png";